export default __webpack_public_path__ + "static/media/energy.51c4bc38.svg";